<script lang="ts">
import { defineComponent } from 'vue'
import * as icons from 'lucide-vue-next'

export default defineComponent({
  name: 'IconLucide',
  props: {
    name: {
      type: String,
      required: true,
    },
    size: {
      type: Number,
      default: 24,
    },
    color: String,
    strokeWidth: {
      type: Number,
      default: 2,
    },
    customClass: {
      type: String,
      default: undefined,
    },
  },
  computed: {
    icon() {
      const iconName = this.name as keyof typeof icons
      return icons[iconName]
    },
  },
})
</script>

<template>
  <component :is="icon" v-bind="{ size, color, strokeWidth }" :class="customClass" />
</template>
